var appName = 'Ask xactus'
var headerTextColor = '#FFFFFF'

var frameURL = 'https://creditplus-webappservice.yanaimpl.com/'
var frameWidth = '400px'
var frameHeight = '575px'

var bottomButtonColor = '#4b868f'
var bottomButtonHeight = '35px'
var bottomButtonWidth = '131px'

var topButtonColor = '#FFFFFF'
var topButtonHeight = '20px'
var topButtonWidth = frameWidth
var topBackgroundColor = '#003262'
var closeButtonColor = '#FFFFFF'
var isInitialLoad = true

var initilaizeWidgjet = {
  init() {
  const element = document.getElementById('yana-bottom-button')
  if(element){
    element.remove()
    document.getElementById('yana-wrapper').remove()
  }
    var yanaBlock = document.querySelector('body')

    var yanaBottomButton = document.createElement('button')
    yanaBottomButton.setAttribute('id', 'yana-bottom-button')
    yanaBottomButton.style.display = 'block'
    yanaBottomButton.style.position = 'fixed'
    yanaBottomButton.style.height = bottomButtonHeight
    yanaBottomButton.style.width = bottomButtonWidth
    yanaBottomButton.style.bottom = '0'
    yanaBottomButton.style.right = '110px'
    yanaBottomButton.style.borderRadius = '4px 4px 0 0'
    yanaBottomButton.style.backgroundColor = bottomButtonColor
    yanaBottomButton.style.zIndex = '9999999999'
    yanaBottomButton.setAttribute('aria-label', 'open chatbot')
    yanaBottomButton.style.border = 'none'
    yanaBottomButton.style.padding = 0
    yanaBottomButton.style.font = 'inherit'
    yanaBottomButton.style.cursor = 'pointer'
    yanaBottomButton.style.outline = 'inherit'
    yanaBottomButton.addEventListener('click', openClose)
    var bottomButtonText = document.createElement('p')
    bottomButtonText.style.position = 'relative'
    bottomButtonText.style.textAlign = 'center'
    bottomButtonText.style.color = headerTextColor
    bottomButtonText.style.margin = 'auto'
    // bottomButtonText.style.fontWeight = 700;

    yanaBottomButton.addEventListener('focus', function() {
      this.style.outline = '5px auto rgba(0, 150, 255, 1)'
      this.style.border = '1px solid rgba(0, 0, 0, 0)'
    })
    yanaBottomButton.addEventListener('blur', function() {
      this.style.outline = 'none'
      this.style.border = 'none'
    })

    var innerText = document.createElement('span')
    innerText.innerHTML = appName
    innerText.style.cursor = 'pointer'
    innerText.style.display = 'block'

    bottomButtonText.appendChild(innerText)
    yanaBottomButton.appendChild(bottomButtonText)
    yanaBlock.appendChild(yanaBottomButton)

    var yanaApp = document.createElement('div')
    yanaApp.style.display = 'none'
    yanaApp.setAttribute('id', 'yana-wrapper')
    yanaApp.style.position = 'fixed'
    yanaApp.style.bottom = '0'
    yanaApp.style.right = '110px'
    yanaApp.style.width = frameWidth
    yanaApp.style.borderRadius = '4px 4px 0 0'
    yanaApp.style.zIndex = '9999999999'

    document.onkeydown = function(evt) {
      evt = evt || window.event
      if (evt.keyCode == 27) {
        if (yanaApp.style.display === 'block') {
          openClose()
        }
      }
    }

    window.addEventListener('message', receiveMessage, false)
    function receiveMessage(event) {
      if (event.data === 'close-iframe') {
        if (yanaApp.style.display === 'block') {
          openClose()
        }
      }
    }

    var yanaHeader = document.createElement('div')
    yanaHeader.setAttribute('id', 'yana-app-header')
    yanaHeader.style.display = 'block'
    yanaHeader.style.position = 'relative'
    yanaHeader.style.height = topButtonHeight
    yanaHeader.style.width = bottomButtonWidth
    yanaHeader.style.right = '-175px'
    yanaHeader.style.borderRadius = '4px 4px 0 0'
    yanaHeader.style.backgroundColor = topBackgroundColor
    yanaHeader.style.zIndex = '9999999999'
    yanaApp.appendChild(yanaHeader)

    var headerText = document.createElement('p')
    headerText.setAttribute('id', 'yana-top-paragraph')
    headerText.style.position = 'relative'
    headerText.style.padding = '8px'
    headerText.style.textAlign = 'center'
    headerText.style.color = headerTextColor
    // headerText.style.fontWeight = 700;
    // headerText.addEventListener("click", openClose);
    // yanaApp.appendChild(headerText);

    var leftText = document.createElement('span')
    leftText.setAttribute('id', 'yana-left-text')
    leftText.innerHTML = appName
    leftText.style.cursor = 'pointer'
    leftText.style.display = 'block'
    headerText.appendChild(leftText)

    var rightText = document.createElement('button')
    rightText.addEventListener('click', openClose)
    rightText.setAttribute('aria-label', 'close chatbot')
    rightText.style.background = topBackgroundColor
    rightText.style.color = topButtonColor
    rightText.style.border = 'none'
    rightText.style.padding = 0
    rightText.style.font = 'inherit'
    rightText.style.cursor = 'pointer'
    rightText.style.outline = 'inherit'

    rightText.setAttribute('id', 'yana-right-text')
    rightText.innerHTML = '-'
    rightText.style.display = 'block'
    rightText.style.cursor = 'pointer'
    rightText.style.position = 'absolute'
    rightText.style.right = '10px'
    rightText.style.top = '0px'
    rightText.style.fontSize = '35px'
    rightText.style.lineHeight = '5px'
    rightText.style.padding = '5px'
    rightText.onmousemove = function() {
      this.style.backgroundColor = topBackgroundColor
      this.style.borderRadius = '2px'
    }
    rightText.onmouseout = function() {
      this.style.backgroundColor = 'inherit'
    }
    rightText.addEventListener('focus', function() {
      this.style.border = '2px solid rgba(0, 150, 255, 1)'
    })
    rightText.addEventListener('blur', function() {
      this.style.border = 'none'
    })
    yanaHeader.appendChild(rightText)
    // yanaHeader.appendChild(headerText);

    var yanaFrame = document.createElement('iframe')
    yanaFrame.setAttribute('id', 'yana-app-wrapper')
    if (!isInitialLoad) {
      yanaFrame.setAttribute('src', frameURL)
    }
    yanaFrame.style.display = 'block'
    yanaFrame.style.position = 'relative'
    yanaFrame.style.height = frameHeight
    yanaFrame.style.width = frameWidth
    yanaFrame.style.border = 0
    yanaFrame.style.transition = 'visibility 3s, opacity 0.5s linear'
    yanaApp.appendChild(yanaFrame)

    yanaBlock.appendChild(yanaApp)
  },
}
// if (document.readyState !== 'loading') {
//   init();
// } else {
//   document.addEventListener('DOMContentLoaded', function () {
//     init();
//   });
// }
function openClose() {
  if (window.screen.width < 1025) {
    window.open(frameURL, '_blank')
  } else {
    var yanaApp = document.getElementById('yana-wrapper')
    var appHeader = document.getElementById('yana-app-header')
    var leftText = document.getElementById('yana-left-text')
    var rightText = document.getElementById('yana-right-text')
    var iframe = document.getElementById('yana-app-wrapper')
    var headerText = document.getElementById('yana-top-paragraph')
    var yanaBottomButton = document.getElementById('yana-bottom-button')
    if (yanaApp.style.display === 'none') {
      if (isInitialLoad) iframe.setAttribute('src', frameURL)
      isInitialLoad = false
      yanaApp.style.display = 'block'
      appHeader.style.width = topButtonWidth
      appHeader.style.right = '0px'
      appHeader.style.height = topButtonHeight
      appHeader.style.backgroundColor = topBackgroundColor
      leftText.style.display = 'block'
      headerText.style.paddingLeft = '24px'
      headerText.style.textAlign = 'left'
      rightText.style.display = 'block'
      yanaBottomButton.style.display = 'none'
      rightText.focus()
    } else {
      yanaApp.style.display = 'none'
      appHeader.style.width = bottomButtonWidth
      appHeader.style.right = '-175px'
      appHeader.style.height = bottomButtonHeight
      appHeader.style.backgroundColor = bottomButtonColor
      leftText.style.display = 'block'
      rightText.style.display = 'none'
      headerText.style.textAlign = 'center'
      headerText.style.paddingLeft = '0px'
      yanaBottomButton.style.display = 'block'
      yanaBottomButton.focus()
    }
  }
}

export default initilaizeWidgjet
